import { Tabs } from "tailwindcss-stimulus-components"

const SESSION_KEY_PREFIX = "tabsSelectedIndex:"

export default class extends Tabs {
  constructor(...args) {
    super(...args)
    this.restoreSelectedIndex()
  }

  connect() {
    super.connect()
  }

  indexValueChanged() {
    super.indexValueChanged()
    this.saveSelectedIndex()
  }

  saveSelectedIndex() {
    const key = this.sessionKey()
    window.sessionStorage.setItem(key, JSON.stringify(this.indexValue))
  }

  restoreSelectedIndex() {
    const key = this.sessionKey()
    const data = window.sessionStorage.getItem(key)
    if (data !== null) {
      try {
        const idx = JSON.parse(data)
        if (typeof idx === 'number' && idx >= 0 && idx < (this.tabTargets?.length || 100)) {
          this.indexValue = idx
        }
      } catch {
        // ignore parse errors
      }
    }
  }

  sessionKey() {
    // Prefer id if present, else fallback to index among all tabs-controller elements
    if (this.element.id) {
      return SESSION_KEY_PREFIX + this.element.id
    } else {
      const all = Array.from(document.querySelectorAll('[data-controller~="tabs"]'))
      const idx = all.indexOf(this.element)
      return SESSION_KEY_PREFIX + idx
    }
  }
}
